module.exports = __webpack_public_path__ + "static/media/add-circle.8276b223.svg";